"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceTypeWeb = exports.getPartnerWeb = exports.getLanguageWeb = exports.getBD4TravelWeb = exports.getB2BMarkupWeb = exports.getAgencyWeb = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_utils_1 = require("@hotelplan/libs.utils");
const normalizeRequestContext_1 = __importDefault(require("./normalizeRequestContext"));
const RequestContext_constants_1 = require("./RequestContext.constants");
function getAgencyWeb() {
    return js_cookie_1.default.get(RequestContext_constants_1.AGENCY_KEY);
}
exports.getAgencyWeb = getAgencyWeb;
function getB2BMarkupWeb() {
    const b2bMarkup = js_cookie_1.default.get(RequestContext_constants_1.B2B_MARKUP_KEY);
    return b2bMarkup ? +b2bMarkup : undefined;
}
exports.getB2BMarkupWeb = getB2BMarkupWeb;
function getBD4TravelWeb() {
    return js_cookie_1.default.get(RequestContext_constants_1.BD4_USER_ID_KEY);
}
exports.getBD4TravelWeb = getBD4TravelWeb;
function getLanguageWeb() {
    return (0, libs_utils_1.getPageLanguage)(js_cookie_1.default.get(RequestContext_constants_1.LANGUAGE_COOKIE_KEY));
}
exports.getLanguageWeb = getLanguageWeb;
function getPartnerWeb() {
    return js_cookie_1.default.get(RequestContext_constants_1.PARTNER_KEY);
}
exports.getPartnerWeb = getPartnerWeb;
function getDeviceTypeWeb() {
    return (0, libs_context_device_type_1.mapDeviceTypeToServerDeviceType)(typeof window !== 'undefined'
        ? (0, libs_context_device_type_1.getDeviceTypeByScreenWidth)(window.innerWidth)
        : libs_context_device_type_1.DeviceType.Desktop);
}
exports.getDeviceTypeWeb = getDeviceTypeWeb;
function getRequestContextWeb(patch) {
    return (0, normalizeRequestContext_1.default)(Object.assign({ agency: getAgencyWeb(), b2bMarkup: getB2BMarkupWeb(), bd4TravelUserId: getBD4TravelWeb(), device: getDeviceTypeWeb(), language: getLanguageWeb(), partner: getPartnerWeb() }, patch));
}
exports.default = getRequestContextWeb;
//# sourceMappingURL=getRequestContextWeb.js.map